import {getMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/packageTourInfo', request)
}

export {get}
